module.exports = __webpack_public_path__ + "img/media-11.e8216b9e.png";